import {
  createRouter,
  createWebHistory,
  type NavigationGuardNext,
  type RouteLocationNormalizedGeneric
} from 'vue-router'
import NProgress from 'nprogress'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // * Public Routes
    {
      path: '/books',
      name: 'library',
      meta: {
        public: true
      },
      component: () => import('../views/Library.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      meta: {
        public: true
      },
      component: () => import('../views/Privacy.vue')
    },
    {
      path: '/health',
      name: 'health',
      meta: {
        public: true
      },
      component: () => import('../views/Health.vue')
    },

    // * Admin Routes
    {
      path: '/admin/login',
      name: 'admin-login',
      meta: {
        guest: true
      },
      component: () => import('../views/admin/AdminLogin.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      meta: {
        guest: true
      },
      redirect: '/admin/login'
    },
    {
      path: '/admin/proxy-config',
      name: 'proxy-config',
      meta: {
        requiresAuth: true,
        requires2FA: true
      },
      component: () => import('../views/admin/ProxyConfig.vue')
    },
    {
      path: '/admin/proxy-logs',
      name: 'proxy-logs',
      meta: {
        requiresAuth: true,
        requires2FA: true
      },
      component: () => import('../views/admin/ProxyLogs.vue')
    },
    {
      path: '/admin/users',
      name: 'admin-users',
      meta: {
        requiresAuth: true,
        requires2FA: true
      },
      component: () => import('../views/admin/Users.vue')
    },
    {
      path: '/admin/profile',
      name: 'admin-profile',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/admin/AdminProfile.vue')
    }
  ]
})

const adminAuth = ({
  to,
  from,
  next
}: {
  to: RouteLocationNormalizedGeneric
  from: RouteLocationNormalizedGeneric
  next: NavigationGuardNext
}) => {
  const admin = localStorage.getItem('admin')
    ? JSON.parse(localStorage.getItem('admin') as string)
    : null

  if (to.meta.requiresAuth && !admin) {
    return next({ name: 'admin-login' })
  }

  if (to.meta.requires2FA && admin && !admin.two_factor_enabled) {
    return next({ name: 'admin-profile' })
  }

  if (to.meta.guest && admin) {
    if (admin.two_factor_enabled) {
      return next({ name: 'proxy-config' })
    }
    return next({ name: 'admin-profile' })
  }

  if (to.name !== 'admin-profile' && admin && !admin.two_factor_enabled && to.meta.requiresAuth) {
    return next({ name: 'admin-profile' })
  }

  return next()
}

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  const loader = document.getElementById('initial-loader')

  if (loader) {
    document.body.removeChild(loader as ChildNode)
  }

  // All routes use admin authentication
  return adminAuth({ to, from, next })
})

router.afterEach(() => {
  NProgress.done()
})

export default router
